import { RootState } from "@v2/store";
import { useSelector } from "react-redux";

export function useProductsRating(): { rating: number, total: number } {
    return useSelector((state: RootState) => state.stamped);
}